import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class WebhookModel extends Model {
  static reducer(action, WebhookModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.Webhook.schema:
        action.payload.forEach((payload) => {
          const dbData = WebhookModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          WebhookModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
WebhookModel.modelName = "WebhookModel";

WebhookModel.fields = {
  id: attr(),
};

export default WebhookModel;